import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansRepaymentLoanInfoComponent from './loansRepaymentLoanInfo.component';

let loansRepaymentLoanInfoModule = angular.module('loansRepaymentLoanInfo', [
  uiRouter
])

.component('loansRepaymentLoanInfo', loansRepaymentLoanInfoComponent)

.name;

export default loansRepaymentLoanInfoModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentLoanInfo/loansRepaymentLoanInfo.js